module.exports = __webpack_public_path__ + "assets/img/btn-view-3ac12047.png";